import axios from "axios";

import { getToken } from "../utils/cookies";

const userRequest = axios.create({
  baseURL: process.env.REACT_APP_USER_URL, // user-api
  headers: {
    Authorization: `Bearer ${getToken()}`,
    accept: "application/json",
  },
});

export const initUserApiInterceptors = () => {
  userRequest.interceptors.request.use(
    (config) => {
      config.headers["Authorization"] = `Bearer ${getToken()}`;
      return config;
    },
    (error) => {
      console.error("Error in UserInterceptors", error);
      return Promise.reject(error);
    }
  );
};

////////////////////////////////////////////////////////////////////////////////////////////////////

export async function getAppTenantName() {
  return userRequest("/customer/info");
}

export async function getRolePermission() {
  return userRequest("/permission/app", {
    params: { name: "erp" },
  });
}
